module.exports = __webpack_public_path__ + "img/upload01.60734c27.png";